import { memo, useMemo } from "react";
import { MarkerNoteByline } from "./MarkerNoteByline";
import { MarkerNoteFrame } from "./MarkerNoteFrame";
import { MarkerNoteText } from "./MarkerNoteText";
import { noteColorsOf } from "./utils";
import type { MarkerNoteCardProps } from "./types";

export const MarkerNoteCard = memo(function MarkerNoteCard({
  note,
  rgb,
}: MarkerNoteCardProps) {
  const colors = useMemo(() => noteColorsOf(rgb), [rgb]);

  return (
    <MarkerNoteFrame rgb={rgb} header={<MarkerNoteByline note={note} />}>
      {/* Keyed by the edit time so an edited note is measured and clamped afresh. */}
      <MarkerNoteText
        key={note.updatedAt}
        content={note.content}
        pillColor={colors.pill}
        pillTextColor={colors.deep}
      />
    </MarkerNoteFrame>
  );
});
